import { __rest } from "tslib";
import * as React from 'react';
/**
 * Represents an Action wrapped in an anchor element or the given component.
 */
export var Action = function (_a) {
    var icon = _a.icon, _b = _a.of, of = _b === void 0 ? 'a' : _b, children = _a.children, props = __rest(_a, ["icon", "of", "children"]);
    return React.createElement(of, props, React.createElement("span", { className: "action-item" },
        React.createElement("i", { className: icon }),
        children));
};
//# sourceMappingURL=Action.js.map